"use client"

import React from "react"
import { SingleFieldTest } from "@/components/testing/single-field-test"
import { FullTestCard } from "@/components/testing/full-test-card"
import type { FlatMapping } from "@/types/ui"
import type { MappingConfig } from "@/types/fbo-api"

interface TestingTabProps {
  allMappings: FlatMapping[]
  entityTypes: string[]
  hasInvalidMappings: boolean
  config: MappingConfig
  testForm: {
    primaryEntityId: string
    entityType: string
    entityId: string
    sourceField: string
  }
  setTestForm: (form: {
    primaryEntityId: string
    entityType: string
    entityId: string
    sourceField: string
  }) => void
}

export function TestingTab({ allMappings, entityTypes, hasInvalidMappings, config, testForm, setTestForm }: TestingTabProps) {

  return (
    <>
      <div className="space-y-6">
        <div>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <FullTestCard
              allMappings={allMappings}
              config={config}
              primaryEntityId={testForm.primaryEntityId}
              setPrimaryEntityId={(id) => setTestForm({ ...testForm, primaryEntityId: id })}
              hasInvalidMappings={hasInvalidMappings}
            />
            <SingleFieldTest
              entityTypes={entityTypes}
              atsSource={config.atsSource}
              entityType={testForm.entityType}
              entityId={testForm.entityId}
              sourceField={testForm.sourceField}
              onEntityTypeChange={(value) => setTestForm({ ...testForm, entityType: value })}
              onEntityIdChange={(value) => setTestForm({ ...testForm, entityId: value })}
              onSourceFieldChange={(value) => setTestForm({ ...testForm, sourceField: value })}
            />
          </div>
        </div>
      </div>
    </>
  )
} 